const FLASHCARDS = '';
module.exports = { FLASHCARDS };